import { useState } from "react";
import { Container, Row, Col, Form, Card } from "react-bootstrap";

function RoteiroColeta() {
  const bairrosDias = {
    // =========================
    // SEGUNDA A SEXTA
    // =========================
    Centro: [
      "Segunda-feira",
      "Terça-feira",
      "Quarta-feira",
      "Quinta-feira",
      "Sexta-feira",
    ],

    // =========================
    // TERÇA-FEIRA SOMENTE
    // =========================
    Pedrinhas: ["Terça-feira"],

    // =========================
    // QUARTA-FEIRA SOMENTE
    // =========================
    Rocinha: ["Quarta-feira"],

    // =========================
    // SEGUNDA E QUARTA
    // =========================
    "Bosque dos Ipês": ["Segunda-feira", "Quarta-feira"],
    "Jardim Modelo": ["Segunda-feira", "Quarta-feira"],
    "Parque Santa Clara": ["Segunda-feira", "Quarta-feira"],
    Pedreira: ["Segunda-feira", "Quarta-feira"],
    "Pingo de Ouro": ["Segunda-feira", "Quarta-feira"],
    "Pq São Francisco 1 e 2": ["Segunda-feira", "Quarta-feira"],
    "Res. Coopemi": ["Segunda-feira", "Quarta-feira"],
    "Res. David Fernandes Coelho": ["Segunda-feira", "Quarta-feira"],
    "Res. Vale das Serras": ["Segunda-feira", "Quarta-feira"],
    "Res. Vista das Paineiras": ["Segunda-feira", "Quarta-feira"],
    "Residencial Mantiqueira": ["Segunda-feira", "Quarta-feira"],
    "Retiro / São Benedito": ["Segunda-feira", "Quarta-feira"],
    "Santa Bárbara": ["Segunda-feira", "Quarta-feira"],
    "São Dimas": ["Segunda-feira", "Quarta-feira"],
    "São Sebastião": ["Segunda-feira", "Quarta-feira"],
    "Vila dos Comerciários 1 e 2": ["Segunda-feira", "Quarta-feira"],
    "Village Santana": ["Segunda-feira", "Quarta-feira"],
    "Villagio Italian": ["Segunda-feira", "Quarta-feira"],

    // =========================
    // QUARTA E SEXTA
    // =========================
    Campinho: ["Quarta-feira", "Sexta-feira"],
    "Chácaras Selles": ["Quarta-feira", "Sexta-feira"],
    Figueira: ["Quarta-feira", "Sexta-feira"],
    "Jardim França 1 e 2": ["Quarta-feira", "Sexta-feira"],
    "Jardim Nova Era": ["Quarta-feira", "Sexta-feira"],
    "Res. Augusto Filippo": ["Quarta-feira", "Sexta-feira"],
    "Residencia Itália": ["Quarta-feira", "Sexta-feira"],
    "Residencial Espanha": ["Quarta-feira", "Sexta-feira"],
    "Santa Luzia": ["Quarta-feira", "Sexta-feira"],
    "Santa Rita": ["Quarta-feira", "Sexta-feira"],
    "São Benedito": ["Quarta-feira", "Sexta-feira"],
    "São Bento": ["Quarta-feira", "Sexta-feira"],
    "Vila Alves": ["Quarta-feira", "Sexta-feira"],
    "Vila Guará": ["Quarta-feira", "Sexta-feira"],
    "Vila Municipal 1 e 2": ["Quarta-feira", "Sexta-feira"],
    "Vila Pajé": ["Quarta-feira", "Sexta-feira"],

    // =========================
    // SEGUNDA E SEXTA
    // =========================
    "Bela Vista": ["Segunda-feira", "Sexta-feira"],
    "Bom Jardim": ["Segunda-feira", "Sexta-feira"],
    Cecap: ["Segunda-feira", "Sexta-feira"],
    "Coelho Neto": ["Segunda-feira", "Sexta-feira"],
    "Colônia Piagui": ["Segunda-feira", "Sexta-feira"],
    "Esplanada/Vila Indiana": ["Segunda-feira", "Sexta-feira"],
    "Jardim Aeroporto": ["Segunda-feira", "Sexta-feira"],
    "Jardim das Figueiras": ["Segunda-feira", "Sexta-feira"],
    "Jardim Esplanada": ["Segunda-feira", "Sexta-feira"],
    "Jardim Independência": ["Segunda-feira", "Sexta-feira"],
    "Jardim Rony": ["Segunda-feira", "Sexta-feira"],
    "Loteamento Nino": ["Segunda-feira", "Sexta-feira"],
    "Parque das Árvores": ["Segunda-feira", "Sexta-feira"],
    "Parque das Garças": ["Segunda-feira", "Sexta-feira"],
    Pedregulho: ["Segunda-feira", "Sexta-feira"],
    Primori: ["Segunda-feira", "Sexta-feira"],
    Quaresmeiras: ["Segunda-feira", "Sexta-feira"],
    "Res.Eurico Dutra": ["Segunda-feira", "Sexta-feira"],
    Resedas: ["Segunda-feira", "Sexta-feira"],
    "Residencial COOPERI": ["Segunda-feira", "Sexta-feira"],
    "Residencial Costa e Silva": ["Segunda-feira", "Sexta-feira"],
    "Santa Edwiges": ["Segunda-feira", "Sexta-feira"],
    "São Manoel": ["Segunda-feira", "Sexta-feira"],
    "Vila Comendador": ["Segunda-feira", "Sexta-feira"],
    "Vila dos Funcionários": ["Segunda-feira", "Sexta-feira"],
    "Vila Galvão": ["Segunda-feira", "Sexta-feira"],
    "Vila Molica": ["Segunda-feira", "Sexta-feira"],
    "Walter Arantes/Matadouro": ["Segunda-feira", "Sexta-feira"],

    // =========================
    // TERÇA E QUINTA
    // =========================
    "Beira Rio 1 e 2": ["Terça-feira", "Quinta-feira"],
    "Campo do Galvão": ["Terça-feira", "Quinta-feira"],
    "Chácara Agrícola Jardim do Vale": ["Terça-feira", "Quinta-feira"],
    "Chácara Santa Maria": ["Terça-feira", "Quinta-feira"],
    "Chácara Vitória": ["Terça-feira", "Quinta-feira"],
    "Clube dos 500": ["Terça-feira", "Quinta-feira"],
    COHAB: ["Terça-feira", "Quinta-feira"],
    "Condominio Pref. Gilberto Filippo": ["Terça-feira", "Quinta-feira"],
    "Engenheiro Neiva": ["Terça-feira", "Quinta-feira"],
    "Flamboyants 1, 2 e 3": ["Terça-feira", "Quinta-feira"],
    Hípica: ["Terça-feira", "Quinta-feira"],
    IAPI: ["Terça-feira", "Quinta-feira"],
    "Internacional Park": ["Terça-feira", "Quinta-feira"],
    "Jardim do Vale 1 e 2": ["Terça-feira", "Quinta-feira"],
    "Jardim Esperança": ["Terça-feira", "Quinta-feira"],
    "Jardim Pérola": ["Terça-feira", "Quinta-feira"],
    "Jardim Primavera": ["Terça-feira", "Quinta-feira"],
    "Jardim Tamandaré": ["Terça-feira", "Quinta-feira"],
    "Jardim Vista Alegre": ["Terça-feira", "Quinta-feira"],
    Mirante: ["Terça-feira", "Quinta-feira"],
    "Nova Guará": ["Terça-feira", "Quinta-feira"],
    "Nova República": ["Terça-feira", "Quinta-feira"],
    "Panorama 1 e 2": ["Terça-feira", "Quinta-feira"],
    "Parque Alberto Bayington": ["Terça-feira", "Quinta-feira"],
    "Parque das Alamedas": ["Terça-feira", "Quinta-feira"],
    "Parque do Sol": ["Terça-feira", "Quinta-feira"],
    "Portal das Colinas": ["Terça-feira", "Quinta-feira"],
    "Residencial Santa Mônica": ["Terça-feira", "Quinta-feira"],
    "Vila Angelina": ["Terça-feira", "Quinta-feira"],
    "Vila Bela": ["Terça-feira", "Quinta-feira"],
    "Vila Brasil": ["Terça-feira", "Quinta-feira"],
    "Vila Ofélia": ["Terça-feira", "Quinta-feira"],
    "Vila Paraíba": ["Terça-feira", "Quinta-feira"],
    "Vila Paulista": ["Terça-feira", "Quinta-feira"],
    "Vila Regina": ["Terça-feira", "Quinta-feira"],
    "Vila Rosa": ["Terça-feira", "Quinta-feira"],
    "Vila Santa Mônica": ["Terça-feira", "Quinta-feira"],
    "Vila Sapé": ["Terça-feira", "Quinta-feira"],
    "Village Mantiqueira": ["Terça-feira", "Quinta-feira"],
  };

  const [bairroSelecionado, setBairroSelecionado] = useState("");

  const bairrosOrdenados = Object.keys(bairrosDias).sort((a, b) =>
    a.localeCompare(b, "pt-BR"),
  );

  return (
    <section className="py-0 bg-light">
      <Container>
        <Row className="text-center mb-4">
          <p className="text-muted">
            Selecione um bairro para ver os dias de coleta
          </p>
        </Row>

        <Row className="justify-content-center">
          <Col md={6}>
            <Form.Select
              value={bairroSelecionado}
              onChange={(e) => setBairroSelecionado(e.target.value)}
            >
              <option value="">Escolha um bairro...</option>
              {bairrosOrdenados.map((bairro, index) => (
                <option key={index} value={bairro}>
                  {bairro}
                </option>
              ))}
            </Form.Select>
          </Col>
        </Row>

        {bairroSelecionado && (
          <Row className="justify-content-center mt-2">
            <Col md={8}>
              <Card className="shadow-sm d-flex flex-row align-items-center p-3">
                <div className="me-4">
                  <Card.Title className="fw-bold mb-0">
                    {bairroSelecionado}
                  </Card.Title>
                  <small className="text-muted">Dias de coleta</small>
                </div>
                <div className="d-flex flex-wrap gap-2">
                  {bairrosDias[bairroSelecionado].map((dia, idx) => (
                    <span
                      key={idx}
                      className="badge bg-success text-white px-3 py-2"
                    >
                      {dia}
                    </span>
                  ))}
                </div>
              </Card>
            </Col>
          </Row>
        )}
      </Container>
    </section>
  );
}

export default RoteiroColeta;
